import {
  hasOptions,
  optionsOf,
  type Condition,
  type FormContent,
} from "@sfc/forms";

/** Display identities as current labels, using the evaluator's comparison mode. */
export function conditionDescription(
  condition: Condition,
  content: FormContent,
  omitQuestion = false,
): string {
  const source = content.questions.find((q) => q.id === condition.questionId);
  const label =
    omitQuestion && source
      ? "Answer"
      : source
        ? `“${source.label || "Untitled question"}”`
        : "Missing question";
  if (condition.op === "isAnswered") return `${label} is answered`;
  if (condition.op === "isEmpty") return `${label} is empty`;
  const comparesOptions =
    condition.compare === "option" ||
    (condition.compare === undefined && source && hasOptions(source.type));
  const value =
    condition.compare === "other"
      ? "Other (their own answer)"
      : comparesOptions
        ? ((source &&
            optionsOf(source).find((option) => option.id === condition.value)
              ?.label) ??
          "Missing option")
        : (condition.value ?? "");
  const operator = {
    equals: "equals",
    notEquals: "does not equal",
    contains: "contains",
  }[condition.op];
  return `${label} ${operator} “${value}”`;
}
